<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 __custom-layout-item">
      <!-- headers -->
      <h4 class="title __custom-title">The following tasks are currently assigned to other user(s).</h4>
      <h4 class="title __custom-title">Please select the tasks below you would like to reassign to {{ list.newAssignee }}</h4>

      <template>
        <div>
          <md-table v-model="list.reassignTasks" @md-selected="onSelect" class="table-striped __custom-table" ref="tableRef">
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="multiple"
              md-auto-select
            >
              <md-table-cell md-label="Task">{{ item.subject }}</md-table-cell>
              <md-table-cell md-label="Status">{{ item.status }}</md-table-cell>
              <md-table-cell md-label="Due Date">{{ item.dateDue }}</md-table-cell>
              <md-table-cell md-label="Assigned To">{{ item.assignee }}</md-table-cell>
            </md-table-row>
          </md-table>          
        </div>
      </template>

      <div class="table table-striped">
        <md-card-actions class="__custom-card-actions">

          <md-button 
            v-if="selected.length"
            class="md-primary __custom-primary-btn" 
            @click="getTaskIds" 
            title="OK" 
          >OK</md-button>
          <md-button class="md-theme-default" @click="closeDialog">Cancel</md-button>
        </md-card-actions>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected: []
    };
  },
  computed: {},
  methods: {
    onSelect: function (items) {
      this.selected = items;
    },
    //add selectedTasks in caseAssignee list
    getTaskIds() {
      this.selected.forEach(el => {
        let selItem = {};
        selItem['taskId'] = el.id;
        selItem['taskUser'] = this.list.newAssignee;
        selItem['taskUserId'] = this.list.newAssigneeId;
        selItem['skipAlert'] = this.list.skipAlert;
        this.list.selectedTasks.push(selItem);
      })

      this.selected = [];
      console.log("this.list: ", this.list);
      this.list.skipReassignTasks = true;
      this.list.showRelatedDialog = false;
    },
    closeDialog() {
      this.list.skipReassignTasks = true;
      this.list.showRelatedDialog = false;
    }
  },
  mounted() {
    //select all tasks by default
    window.setTimeout(() => {
      const checkBoxElement = this.$refs.tableRef.MdTable.contentEl.querySelector(".md-table-head input[type='checkbox']");
      checkBoxElement.click();
    }, 1000);
  }
};
</script>

<style>
i.md-icon.md-icon-font.md-bottom-bar-icon.md-theme-default.__closeDialogIcon {
  cursor: pointer;
  width: 17px;
  float: right;
  padding-right: 8px;
  color: #fff;
}

span.md-dialog-title.md-title.__custom-dialog-title {
  background-color: #E4925C;
  color: #fff;
  font-weight: 500;
  text-align: center;
  padding: 10px 0px 10px;
}
.__custom-dialog-content.md-dialog-content.md-theme-default {
  padding: 0px;
}
.md-table.table-striped.__custom-table.md-theme-default table {
  width: 95%;
  margin: 10px 5px 0px 28px;
  border-spacing: 0;
  border-collapse: collapse;
  overflow: hidden;
  border: 1px solid #ddd !important;
}
.md-table.table-striped.__custom-table.md-theme-default th .md-table-head-label {
  color: #fff;
  font-weight: 400;
}
.md-table.table-striped.__custom-table.md-theme-default thead {
  background: #878787;
}
</style>

<style lang="scss" scoped>
.md-layout-item.md-size-100.__custom-layout-item {
  padding-right: 0px;
  padding-left: 0px;
}
h4.title.__custom-title {
  text-align: center;
  color: #000000 !important;
  margin: 3px 3px 14px 0px;
  font-weight: 500;
}
.md-content.md-table.table-striped.md-theme-default {
  margin-bottom: 2px;
  height: 320px;
}
</style>
